"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$grey, _theme$palette2, _theme$palette2$grey, _theme$palette3, _theme$palette3$grey, _theme$palette4, _theme$palette4$prima;

  return {
    accordion: {
      background: "none",
      borderBottom: "4px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$grey = _theme$palette.grey) === null || _theme$palette$grey === void 0 ? void 0 : _theme$palette$grey[300]),
      borderTop: "1px solid ".concat((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$grey = _theme$palette2.grey) === null || _theme$palette2$grey === void 0 ? void 0 : _theme$palette2$grey[300]),
      borderRadius: 0,
      boxShadow: "none",
      "&::before": {
        display: "none"
      },
      "& .MuiAccordionDetails-root": {
        display: "block",
        padding: theme.spacing(0)
      }
    },
    summary: {
      background: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$grey = _theme$palette3.grey) === null || _theme$palette3$grey === void 0 ? void 0 : _theme$palette3$grey[100],
      padding: theme.spacing(0, 2)
    },
    expanded: {
      background: "none"
    },
    headline: {
      color: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 ? void 0 : (_theme$palette4$prima = _theme$palette4.primary) === null || _theme$palette4$prima === void 0 ? void 0 : _theme$palette4$prima.main
    }
  };
});
var _default = styles;
exports.default = _default;